import XEUtils from 'xe-utils'
import 'vxe-table-quantdata/lib/style.css'
import Vue from 'vue'
import httpManager from '../../util/common'
import { Handler } from 'leaflet'
Vue.use('vxe-utils');
Vue.use('vxe-table');

let vm = {
  delimiters: ['{', '}'],
  props: {
    type: String,
    soaid: String,
    sname: String,
    coaid: String,
    cname: String,
    report: Array,
    defaultId:String
  },
  data: () => {
    return {
      tableColumnSupply: [],
      tableColumnCustomer: [],
      tableColumn: [],
      entityCount: 0,
      loading: false,
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
        align: 'center',
        pageSizes: [10, 20, 50, 100, 200, 500],
        layouts: ['PrevPage', 'Number', 'NextPage'],
        perfect: true,
        pagerCount: 3
      },
      data: [], //表单的数据
      exportConfig: {},
    }
  },
  methods: {
    openDataExport () {
      let s = this.soaid+"_供应商_"
      if(this.type == 'customer'){
        s = this.coaid+"_客户_"
      }
        this.$refs.xTable_data.openExport({
                filename: s+XEUtils.toDateString(new Date().getTime(), 'yyyyMMddHHmmss'),
                original: false,
                types: ['csv']
              })
        },
    pageChange({ currentPage, pageSize }) {
      this.page.currentPage = currentPage
      this.page.pageSize = pageSize
      this.getSCData()
    },
    getSCData() {
      let self = this
      if(!self.soaid & !self.coaid)
        return
      let report = self.report
      self.loading = true
      let params = new Map()
      params.set("pagenum", self.page.currentPage)
      params.set("pagesize", self.page.pageSize)
      params.set("soaid", self.soaid)
      params.set("coaid", self.coaid)
      if (report) {
        params.set("report", report)
      }
      // 点击清除时 report不存在--清空对应的表格内容
      else{
        if(this.type==='supplier'){
            params.set("soaid", self.defaultId)
            params.set("coaid", self.coaid)
          }
        else{
            params.set("soaid", self.soaid)
            params.set("coaid", self.defaultId)
          }
      }
      if (self.type == 'supplier')
        self.tableColumn = self.tableColumnSupply
      else
        self.tableColumn = self.tableColumnCustomer
      let pathVars = new Map()
      pathVars.set("type", self.type)
      httpManager("sc_table_data", params, null, null, pathVars)
        .then(response => {
          self.data = response.data.data
          let page = response.data.page
          self.page.total = page.total
          self.loading = false
        })
        .catch(error => {
          // console.log(error)
          self.loading = false
        })
    },
  },
  mounted () {
    this.getSCData()
    this.tableColumnSupply=[
      {type: 'seq', width: 50},
      {title: this.$t('supplychain.supplier_name'), field: "supplier_name"},
      {title: this.$t('supplychain.customer_name'), field: "customer_name"},
      {title: this.$t('supplychain.report_period'), field: "reporting_period"},
      {title: this.$t('supplychain.amount_cny'), field: "amount_cny", formatter:({ cellValue })=>{return cellValue ? `${XEUtils.commafy(XEUtils.toNumber(cellValue), { digits: 2 })}`:''}},
      {title: this.$t('supplychain.proportion_of_sales'), field: "rev"},
      {title: this.$t('supplychain.proportion_of_cost'), field: "cogs"},
      {title: this.$t('supplychain.business'), field: "business"},
      {title: this.$t('supplychain.product'), field: "product"},
      {title: this.$t('supplychain.relationship'), field: "connection_relation"},
      {title: this.$t('supplychain.disclosing_party_name'), field: "disclosure_party_name"},
      {title: this.$t('supplychain.source'), field: "source_url", slots: {default: 'num_default'}}]
    this.tableColumnCustomer=[
      {type: 'seq', width: 50},
      {title: this.$t('supplychain.customer_name'), field: "customer_name"},
      {title: this.$t('supplychain.supplier_name'), field: "supplier_name"},
      {title: this.$t('supplychain.report_period'), field: "reporting_period"},
      {title: this.$t('supplychain.amount_cny'), field: "amount_cny", formatter:({ cellValue })=>{return cellValue ? `${XEUtils.commafy(XEUtils.toNumber(cellValue), { digits: 2 })}`:''}},
      {title: this.$t('supplychain.proportion_of_cost'), field: "cogs"},
      {title: this.$t('supplychain.proportion_of_sales'), field: "rev"},
      {title: this.$t('supplychain.business'), field: "business"},
      {title: this.$t('supplychain.product'), field: "product"},
      {title: this.$t('supplychain.relationship'), field: "connection_relation"},
      {title: this.$t('supplychain.disclosing_party_name'), field: "disclosure_party_name"},
      {title: this.$t('supplychain.source'), field: "source_url", slots: {default: 'num_default'}}]
  },
  watch: {
    report: function () {
      this.getSCData()
    },
    soaid: function () {
      this.getSCData()
    },
    coaid: function () {
      this.getSCData()
    },
  },
}
Vue.component("sc-view-table", vm)
export default vm



// WEBPACK FOOTER //
// ./src/supplychain/js/sc_table.js